import { createContext, useContext } from 'react';

import { Diagnostic } from './types';

export const DiagnosticContext = createContext<Diagnostic[] | null>(null);

export function DiagnosticProvider({
  children,
  diagnostics
}: {
  children: React.ReactNode;
  diagnostics: Diagnostic[] | null;
}) {
  return <DiagnosticContext.Provider value={diagnostics}>{children}</DiagnosticContext.Provider>;
}

export function useDiagnostics() {
  return useContext(DiagnosticContext);
}
